import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let {
  TABLE_SELECTED_COLOR,
  TABLE_TEXT_COLOR,
  TABLE_BG_COLOR,
  BASE_FONT_COLOR,
  BUTTON_WHITE_HOVER_BG_COLOR,
  ERROR_BACKGROUND_COLOR,
  ERROR_BORDER_COLOR,
  ERROR_TEXT_COLOR
} = constants;

let styles = {
  base: {
    display: 'flex',
    flexShrink: 0,
    flexWrap: 'wrap',
    alignItems: 'center',
    height: 30,
    width: '100%',
    backgroundColor: TABLE_SELECTED_COLOR,
    color: TABLE_TEXT_COLOR,
    borderBottom: `1px solid ${TABLE_BG_COLOR}`
  },
  input: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    height: 30,
    margin: '0 10px'
  },
  label: {
    flexShrink: 0,
    fontSize: 14,
    fontWeight: 500,
    marginRight: 10
  },
  button: {
    flexShrink: 0,
    background: 'none',
    border: '1px solid',
    fontSize: '0.9em',
    textTransform: 'capitalize',
    maxHeight: 25,
    boxSizing: 'border-box',
    fontWeight: 400,
    padding: '3px 10px',
    ':hover': {
      backgroundColor: BUTTON_WHITE_HOVER_BG_COLOR
    }
  },
  date: {
    color: BASE_FONT_COLOR,
    padding: 5
  },
  error: {
    marginLeft: 10,
    padding: '0 5px',
    color: ERROR_TEXT_COLOR,
    backgroundColor: ERROR_BACKGROUND_COLOR,
    border: `3px solid ${ERROR_BORDER_COLOR}`
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/datebar/DateBar.styles.js